// Auto-generated file - do not edit manually
export const LOCALE_HASH = '99a37a77';
